import { IconButton } from '@mui/material';
import { PlayArrow, Pause, Replay10, Forward10 } from '@mui/icons-material';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import { SKIP_BACKWARD_SECONDS, SKIP_FORWARD_SECONDS } from '@constants/config';

export default function AudioPlayerControls() {
  const { currentEpisode, isPlaying, togglePlay, skip } = useAudioPlayer();

  const handleSkipBackward = () => {
    skip(-SKIP_BACKWARD_SECONDS);
  };

  const handleSkipForward = () => {
    skip(SKIP_FORWARD_SECONDS);
  };

  const disabled = !currentEpisode;

  return (
    <>
      <IconButton
        onClick={handleSkipBackward}
        disabled={disabled}
        size="small"
        aria-label="Skip back 10 seconds"
        title="Skip back 10 seconds"
      >
        <Replay10 />
      </IconButton>

      <IconButton
        onClick={togglePlay}
        disabled={disabled}
        color="primary"
        size="large"
        aria-label={isPlaying ? 'Pause episode' : 'Play episode'}
        title={isPlaying ? 'Pause episode' : 'Play episode'}
      >
        {isPlaying ? <Pause /> : <PlayArrow />}
      </IconButton>

      <IconButton
        onClick={handleSkipForward}
        disabled={disabled}
        size="small"
        aria-label="Skip forward 10 seconds"
        title="Skip forward 10 seconds"
      >
        <Forward10 />
      </IconButton>
    </>
  );
}
